import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import { withRouter, Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const styles = theme => ({
  Tabs: {
    backgroundColor: 'white',
    color: theme.palette.primary.main,
  },
});


export function NavBar(props) {
  const {
    classes, onlySearch, location, width,
  } = props;
  const activeTabIndex = ['search', 'overview', 'pedigree', 'measures', 'lifeline'].findIndex(tabName => location.pathname.split('/').pop() === tabName);

  return (
    <Tabs
      className={classes.Tabs}
      centered
      value={activeTabIndex !== -1 ? activeTabIndex : 1}
      indicatorColor="primary"
      fullWidth={isWidthDown('sm', width)}
    >
      <Tab
        replace
        icon={<FontAwesomeIcon icon="search" />}
        label="Search"
        component={Link}
        to="search"
      />

      <Tab
        replace
        disabled={onlySearch}
        icon={<FontAwesomeIcon icon="info-circle" />}
        label="Overview"
        component={Link}
        to="overview"
      />

      <Tab
        replace
        disabled={onlySearch}
        icon={<FontAwesomeIcon icon="sitemap" />}
        label="Pedigree"
        component={Link}
        to="pedigree"
      />

      <Tab
        replace
        disabled={onlySearch}
        icon={<FontAwesomeIcon icon="pencil-ruler" />}
        label="Measures"
        component={Link}
        to="measures"
      />

      <Tab
        replace
        disabled={onlySearch}
        icon={<FontAwesomeIcon icon="heartbeat" />}
        label="Lifeline"
        component={Link}
        to="lifeline"
      />
    </Tabs>
  );
}


NavBar.propTypes = {
  onlySearch: PropTypes.bool.isRequired,
  classes: PropTypes.shape().isRequired,
  location: PropTypes.shape().isRequired,
  width: PropTypes.string.isRequired,
};

export default withRouter(withWidth()(withStyles(styles)(NavBar)));



// WEBPACK FOOTER //
// ./src/layout/top-panel/NavBar.jsx